// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  // apiKey: "AIzaSyA5GTg8YkES22gtpzW7_kRep4wvJ3-gJH8",
  // authDomain: "kalamazoo-admin.firebaseapp.com",
  // projectId: "kalamazoo-admin",
  // storageBucket: "kalamazoo-admin.appspot.com",
  // messagingSenderId: "29060324830",
  // appId: "1:29060324830:web:0e2e59a39a8cd4f22c114f"

  apiKey: "AIzaSyCN7lgLWwHHRaTlOT1rNGL0rGYVhy6Jqak",
  authDomain: "thebestlocaleats-b667d.firebaseapp.com",
  projectId: "thebestlocaleats-b667d",
  storageBucket: "thebestlocaleats-b667d.appspot.com",
  messagingSenderId: "285237934364",
  appId: "1:285237934364:web:b600c0a664a9dd17dc62d9",
  measurementId: "G-3VQ3M96TLD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export default app;